﻿$.fn.dxCtrlContentPlanitiReunion = function custom_dxCtrlContentPlanitiReunion(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcontentplanitireunion dx-ctrl");
        this.createInstance(new cdxCtrlContentPlanitiReunion(this, option));
    }
    return this;
}

window.cdxCtrlContentPlanitiReunion = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var jauge = null
    function mConstruit() {
        //fichier réunion gestionnaire
        container.empty();
        container.css("padding", "0 25px 25px 25px")
        var dxScroll = $("<div/>").appendTo(container).dxScrollView({}).dxScrollView("instance")
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()
        option.bddCtrl.mAjaxCall({ command: "getdataplanitireunion", id_planiti_reunion: option.data.id_planiti_reunion }, function (data) {
            dataPlanitiReunion = data.planiti_reunion[0]

            container.css("text-decoration", ((dataPlanitiReunion.date_debut < parametre.dateNow) ? "line-through" : ""))
            var isAnnule = true
            data.planiti_reunion_orga.forEach(function (planitiReunionOrga, idx) {
                if (planitiReunionOrga.date_annulation == null) isAnnule = false
            })
            if (isAnnule) container.css("text-decoration", "line-through")


            $("<div/>").appendTo(dxScroll.content()).dxCtrlPlanitiReunionDetail({
                bddCtrl: option.bddCtrl,
                planitiReunion: dataPlanitiReunion
            })
            switch (parseInt(dataPlanitiReunion.id_type_lieu)) {
                case 0: break;
                case 1:
                    $("<div style='margin-top:25px;font-weight:bold;font-size:140%;margin-bottom:5px;' class='dx-theme-accent-as-text-color'>Lien zoom administrateur</div>").appendTo(dxScroll.content())
                    $("<a href='" + dataPlanitiReunion.url_maitre_zoom + "' target='_blank'>" + dataPlanitiReunion.url_maitre_zoom + "</a>").appendTo(dxScroll.content())
                    break;
            }

            $("<div style='padding-top:25px;padding-left:30px;'/>").appendTo(dxScroll.content()).dxCtrlPlanitiReunionOrgaDetail({
                bddCtrl: option.bddCtrl,
                dataPlanitiReunion: data
            })

            //var url = parametre.url_appli + "/" + option.bddCtrl.nom_base + "/" + dataPlanitiReunion.id_planiti + "/" + dataPlanitiReunion.id_planiti_reunion + "/0/0/planiti"
            //$("<div style='margin-top:25px;font-weight:bold;font-size:140%;margin-bottom:5px;' class='dx-theme-accent-as-text-color'>Lien sur la réunion</div>").appendTo(dxScroll.content())
            //$("<a href='" + url + "' target='_blank'>" + url + "</a>").appendTo(dxScroll.content())

            //annulation
            if (data.planiti_reunion_orga.filter(function (planitiReunionOrga, idx) {
                return planitiReunionOrga.date_annulation == null
            }).length > 0) {
                var dxBtAnnule = $("<div style='margin-top:25px;'/>").appendTo(dxScroll.content()).dxCtrlButton({
                    text: "Annuler la réunion",
                    onClick: function (e) {
                        dxBtAnnule.element().hide()
                        $DivAnnule.slideDown(300)
                    }
                }).dxCtrlButton("instance")
            }

            var $DivAnnule = $("<div style='display:none;margin-top:25px;padding:15px;border:" + theme.border + ";width:100%;max-width:600px;'/>").appendTo(dxScroll.content())
            $("<div style='font-size:200%'>Annuler la réunion pour tous les participants</div>").appendTo($DivAnnule)

            var dxHtmlEditorAnnule = $("<div style='width:100%;height:200px;margin:0;padding:0;border:" + theme.border + ";'/>").appendTo($DivAnnule).dxCtrlBuilderEmailHtmlEditor({
                bddCtrl:option.bddCtrl,
                html: "Bonjour,<br/>Pour une raison indépendante de notre volonté, nous sommes obligé d'annuler la réunion.<br/>Nous sommes désolé pour ce désagrément et nous vous proposons de reprendre rendez-vous sur un autre créneaux.<br/>Cordialement",
                //toolbar: '',
                onContentReady: function (e) {
                    e.component.element().css("height", "150px")
                }
            }).dxCtrlBuilderEmailHtmlEditor("instance")
            var $Table = $("<table style='margin:10px;'/>").appendTo($DivAnnule)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td/>").appendTo($Tr)
            var dxBtConfAnnule = $("<div/>").appendTo($Td).dxCtrlButton({
                text: "Confirmer l'annulation",
                onClick: function (e) {
                    var dataToBeSend = {
                        command: "annuleplanitireunionallorga",
                        id_planiti_reunion: dataPlanitiReunion.id_planiti_reunion,
                        text_annulation: dxHtmlEditorAnnule.mGetContent()
                    }
                    jauge.mShow()
                    option.bddCtrl.mAjaxCall(dataToBeSend, function (data) {
                        mNotify("La réunion a été annulé", "succes", 6000)
                        mConstruit()
                        jauge.mHide()
                    })
                }
            }).dxCtrlButton("instance")
            var $Td = $("<td/>").appendTo($Tr)
            var dxBtAnnuleAnnule = $("<div/>").appendTo($Td).dxCtrlButton({
                text: "Annuler",
                onClick: function (e) {
                    $DivAnnule.slideUp(300)
                    dxBtAnnule.element().show()
                }
            }).dxCtrlButton("instance")

            if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me })
            jauge.mHide()
        })
    }

    this.element = function () { return container; }

    mConstruit();
}